<div
  class="eventq-button-wrap"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <button
    matButton
    [class]="'eventq-button eventq-button--' + variant() + ' eventq-button--' + size()"
    [class.eventq-button--active]="active()"
    [disabled]="disabled()"
    [type]="type()"
    (click)="pressed.emit()"
  >
    <span class="eventq-button__content">
      @if (iconSrc()) {
        <img class="eventq-button__icon" [src]="iconSrc()! | prefixUrl" alt="" />
      }
      @if (matIcon(); as icon) {
        <mat-icon class="eventq-button__mat-icon">{{ icon }}</mat-icon>
      }
      <span class="eventq-button__label">{{ label() }}</span>
      @if (badgeCount() !== null) {
        <span class="eventq-button__badge">{{ badgeCount() }}</span>
      }
    </span>
  </button>
  @if (showHelp() && helpText()) {
    <span class="eventq-button__help" role="tooltip">{{ helpText() }}</span>
  }
</div>
